import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLocal } from '../utils/localStorageOps';

function RedirectSignUpRoute ({ children }) {
  const documento = getLocal('documentocadastro') 
  const location = (
    getLocal('nomecadastro') ? (
      getLocal('zoop_id') ? (
        ("/cadastro/passo3")
      ) :
        (
          ("/cadastro/passo2")
        )
    ) : (
      ("/cadastro/passo1")
    )
  ) 

  // console.log(window.location.pathname)

  if(window.location.pathname === location)
    return children
  else 
    return documento ? <Navigate to={location}/> : children
}

export default RedirectSignUpRoute